import { ref, onMounted, onBeforeUnmount } from 'vue'

export default function useHighlightActions() {
  const codeDialog = ref(false)
  const dialogHTML = ref('')

  const handleCopy = (e: any) => {
    const btn = e.target?.closest?.('.highlight-copy-btn')
    if (!btn) return
    const container = btn.closest('.highlight-container')
    const code = container?.querySelector('code')
    if (!code) return
    navigator.clipboard.writeText(code.innerText)
    const actionName = btn.querySelector('.action-name')
    if (!actionName) return
    actionName.innerText = 'コピーしました！'
    setTimeout(() => { actionName.innerText = 'コードをコピーする' }, 1000)
  }

  const handleZoom = (e: any) => {
    const btn = e.target?.closest?.('.highlight-zoom-btn')
    if (!btn) return
    const container = btn.closest('.highlight-container')
    if (!container) return
    dialogHTML.value = container.outerHTML
    codeDialog.value = true
  }

  onMounted(() => {
    document.addEventListener('click', handleCopy)
    document.addEventListener('click', handleZoom)
  })

  onBeforeUnmount(() => {
    document.removeEventListener('click', handleCopy)
    document.removeEventListener('click', handleZoom)
  })

  return { codeDialog, dialogHTML }
}
